import store from '@/store';
import { leaseType,leasePaymentType } from '@/util/dictList.js'
export const carPositionOption = {
  height: 'auto',
  calcHeight: 80,
  tip: false,
  searchShow: true,
  searchMenuSpan: 12,
  border: true,
  index: false,
  filterBtn: false,
  refreshBtn: false,
  columnBtn: false,
  searchShowBtn: false,
  selection: true,
  viewBtn: false,
  addBtn: false,
  addTitle:"绑定产品类型",
  delBtn: false,
  editBtn: false,
  dialogType: 'dialog',
  dialogClickModal: false,
  menu: false,
  column: [
    {
      label: '产品类型',
      prop: 'productName',
      type: 'select',
      display: false,
      search: false,
      hide: false,
      showColumn: false,
    },
    {
      label: '产品类型',
      prop: 'productNameId',
      type: 'select',
      search: true,
      hide: true,
      dicData: store.getters.porductTypes,
      props: {
        label: 'label',
        value: 'id',
      },
      searchOrder: 1000,
      rules:[
        {
          required: true,
          message: '请选择产品类型',
          trigger: 'blur',
        }
      ]
    },
    {
      label: '租期',
      prop: 'tenancyTerm',
      type: 'select',
      search: true,
      hide: false,
      dicData: leaseType,
      searchOrder: 998,
      rules:[
        {
          required: true,
          message: '请选择租期',
          trigger: 'blur',
        }
      ]
    },
    {
      label: '租付类型',
      prop: 'type',
      type: 'select',
      search: true,
      hide: false,
      dicData: leasePaymentType,
      searchOrder: 997,
      rules:[
        {
          required: true,
          message: '请选择租付类型',
          trigger: 'blur',
        }
      ]
    },
    {
      label: '租率',
      prop: 'rate',
      type: 'select',
      search: true,
      searchClearable: true,
      hide: false,
      dicData:[],
      props: {
        label: "lable",
        value: "rate",
      },
      searchOrder: 999,
      rules: [
        {
          required: true,
          message: '请选择租付类型',
          trigger: 'blur',
        }
      ]
    },
    
    {
      label: '是否禁用',
      prop: 'status',
      display: false,
      type: 'radio',
      search: true,
      showColumn: false,
      slot: true,
      type: 'select',
      dicData: [
        {
          label: '否',
          value: 0,
        },
        {
          label: '是',
          value: 1,
        },
      ],
      searchOrder: 996,
    },
  ],
};
